<template>
  <div class="incenters">
    <!-- style="border: 1px solid red;" -->
    <div>
      <!-- <Commonbtn title="导出"></Commonbtn> -->
      <div class="topstate" v-for="(item , index) of state" :key="index" :class="[{ 'ativte' : onchage == index}]" @click="clicktab(index)">
        {{ item.title }}
      </div>
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div v-if="tableflag">
      <Commontable  colnum=7 :loadingTable="loadingTable" :tableData="tableDataDetail" :headerData="headerData" height="100%"></Commontable>
    </div>
    <div v-if="tableflagtow">
      <Commontable colnum=7 :loadingTable="loadingTable" :tableData="tableDataUnique" :headerData="headerData1" height="100%"></Commontable>
    </div>
  </div>
</template>

<script>
import Commontable from '../../../components/common-table.vue'
import Commonbtn from '../../../components/common-btn.vue'
import {
  AsnDetail,
  AsnUnique,
} from '@/api/home'
export default {
  components: {
    Commontable,
    Commonbtn,
  },
  props: {
    asnmid: {
      type: String,
      default: ""
    },
    tableDataUnique: {  
      type: Array,
      default: []
    },
    tableDataDetail: {
      type: Array,
      default: []
    },
  },
  data: function () {
    return {
      loadingTable: false,
      tableData1: [
      ],
      headerData1: [{
        prop: 'id',
        label: '序号',
        columnwidth: 120
      },
      {
        prop: 'InvAddCode',
        label: '商品代码',
        columnwidth: 220
      },
      {
        prop: 'Batch',
        label: '批号',
        columnwidth: 220
      },
      {
        prop: 'InvUniqueCode',
        label: '唯一码',
        columnwidth: 220
      },
      {
        prop: 'Quantity',
        label: '数量',
        columnwidth: 220
      },
      ],
      tableData: [
      ],
      headerData: [{
        prop: 'id',
        label: '序号',
        columnwidth: 120
      },
      {
        prop: 'VouDCode',
        label: '来源单据明细编号',
        columnwidth: 230
      },
      {
        prop: 'InvAddCode',
        label: '商品代码',
        columnwidth: 230
      },
      {
        prop: 'InvName',
        label: '商品名称',
        columnwidth: 230
      },
      {
        prop: 'Batch',
        label: '批号',
        columnwidth: 230
      },
      {
        prop: 'ManuDate',
        label: '生产日期',
        columnwidth: 230
      },
      {
        prop: 'ValiDate',
        label: '有效期至',
        columnwidth: 230
      },
      {
        prop: 'Quantity',
        label: '上架数量',
        columnwidth: 230
      },
      {
        prop: 'TaxUnitPrice',
        label: '原币含税单价',
        columnwidth: 230
      },
      {
        prop: 'TaxRate',
        label: '税率',
        columnwidth: 230
      },
      {
        prop: 'ExchangeRate',
        label: '汇率',
        columnwidth: 230
      },
      {
        prop: 'UnitPrice',
        label: '原币单价',
        columnwidth: 230
      },
      {
        prop: 'Sum',
        label: '原币价税合计',
        columnwidth: 230
      },
      {
        prop: 'Money',
        label: '原币金额',
        columnwidth: 230
      },
      {
        prop: 'TaxPrice',
        label: '原币税额',
        columnwidth: 230
      },
      {
        prop: 'NatSum',
        label: '本币价税合计',
        columnwidth: 230
      },
      {
        prop: 'NatMoney',
        label: '本币金额',
        columnwidth: 230
      },
      {
        prop: 'NatTaxPrice',
        label: '本币税额',
        columnwidth: 230
      },
      {
        prop: 'ChineseLabel',
        label: '中文标签',
        columnwidth: 230
      },
      {
        prop: 'RegistrationNo',
        label: '注册证号',
        columnwidth: 230
      },
      ],
      state: [{
        title: '明细'
      },
      {
        title: '唯一码'
      }
      ],
      onchage: 0,
      tableflag: true,
      tableflagtow: false
    }
  },
  mounted() { },
  methods: {
    // 唯一码明细
    async asnUnique() {
      let {
        data,
        code
      } = await AsnUnique({
        asnmid: this.asnmid
      })
      if (code == 0) {
        this.tableData1 = data
      }
    },
    // 明细
    async asnDetail() {
      let {
        data,
        code
      } = await AsnDetail({
        asnmid: this.asnmid
      })
      if (code == 0) {
        this.tableData = data
      }
    },
    clicktab(index) {
      if (index == '0') {
        this.tableflag = true
        this.tableflagtow = false
        this.asnDetail()
      } else {
        this.tableflagtow = true
        this.tableflag = false
        this.asnUnique()
      }
      if (this.onchage != index) {
        this.onchage = index
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ativte {
  border: 1px solid red;
  color: #e71d43;
  background-color: #fce8ec;
  transition: 0.2s linear;
}

.incenters {
  height: 100%;
  font-family: "微软雅黑";

  div {
    margin-left: 8px;
    margin-right: 8px;
    margin-top: 5px;
    margin-bottom: 5px;
    // width: 100%;
  }
}

.topstate {
  width: 100px;
  height: 32px;
  font-size: 14px;
  border: 1px solid #e6e6e6;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
}
</style>
